import {
  OrderBoard,
  OrderBoardList,
  MoveCardRequest,
  UpdateCardStatusRequest,
  UpdateCardDetailsRequest,
  CreateCustomBoardRequest,
  CreateCardRequest,
  ImportEtsyOrdersRequest,
  OrderBoardCard,
} from '../types/orderBoard';
import { BaseApiService } from './baseApiService';

class OrderBoardService extends BaseApiService {
  async getAllBoards(): Promise<OrderBoardList> {
    await this.ensureInitialized();
    const response = await this.api.get<OrderBoardList>('/admin/boards');
    return response.data;
  }

  async getBoardByOrderId(orderId: number): Promise<OrderBoard> {
    await this.ensureInitialized();
    const response = await this.api.get<OrderBoard>(
      `/admin/boards/order/${orderId}`
    );
    return response.data;
  }

  async getBoardsByOrderId(orderId: number): Promise<OrderBoard[]> {
    await this.ensureInitialized();
    const response = await this.api.get<OrderBoard[]>(
      `/admin/boards/order/${orderId}/boards`
    );
    return response.data;
  }

  async getBoardByOrderItemId(orderItemId: number): Promise<OrderBoard> {
    await this.ensureInitialized();
    const response = await this.api.get<OrderBoard>(
      `/admin/boards/order-item/${orderItemId}`
    );
    return response.data;
  }

  async getBoardById(boardId: number): Promise<OrderBoard> {
    await this.ensureInitialized();
    const response = await this.api.get<OrderBoard>(`/admin/boards/${boardId}`);
    return response.data;
  }

  async createBoardForOrder(orderId: number): Promise<OrderBoard> {
    await this.ensureInitialized();
    const response = await this.api.post<OrderBoard>(
      `/admin/boards/order/${orderId}`
    );
    return response.data;
  }

  async createBoardsForOrder(orderId: number): Promise<OrderBoard[]> {
    await this.ensureInitialized();
    const response = await this.api.post<OrderBoard[]>(
      `/admin/boards/order/${orderId}/boards`
    );
    return response.data;
  }

  async createCustomBoard(
    request: CreateCustomBoardRequest
  ): Promise<OrderBoard> {
    await this.ensureInitialized();
    const response = await this.api.post<OrderBoard>(
      '/admin/boards/custom',
      request
    );
    return response.data;
  }

  async createCard(request: CreateCardRequest): Promise<OrderBoardCard> {
    await this.ensureInitialized();
    const response = await this.api.post<OrderBoardCard>(
      '/admin/boards/cards',
      request
    );
    return response.data;
  }

  async importEtsyOrders(
    request: ImportEtsyOrdersRequest
  ): Promise<OrderBoard[]> {
    await this.ensureInitialized();
    const response = await this.api.post<OrderBoard[]>(
      '/admin/boards/import/etsy',
      request
    );
    return response.data;
  }

  async moveCard(
    boardId: number,
    cardId: number,
    request: MoveCardRequest
  ): Promise<void> {
    await this.ensureInitialized();
    await this.api.post(`/admin/boards/cards/${cardId}/move`, request);
  }

  async updateCardStatus(
    boardId: number,
    cardId: number,
    request: UpdateCardStatusRequest
  ): Promise<void> {
    await this.ensureInitialized();
    await this.api.post(`/admin/boards/cards/${cardId}/status`, request);
  }

  async updateCardDetails(
    cardId: number,
    request: UpdateCardDetailsRequest
  ): Promise<void> {
    await this.ensureInitialized();
    await this.api.put(`/admin/boards/cards/${cardId}`, request);
  }
}

export const orderBoardService = new OrderBoardService();
